module.exports = __webpack_public_path__ + "static/media/kun-10.jpeg";